import { setErrorStatusCode } from 'state/concepts/errors/actions';

const makeSetErrorToStore = (dispatch, requestStatus) => () => {
  dispatch(setErrorStatusCode(requestStatus));
};

export default makeSetErrorToStore;
